import { cn } from '@/shared/lib/utils'

interface CurrencyDisplayProps {
  amount: number
  currency?: string
  locale?: string
  /** Show color coding: green for positive, red for negative */
  colored?: boolean
  className?: string
}

/**
 * Renders a financial amount with locale-aware formatting and tabular numbers.
 * Used in DataTable cells, balance widgets, and detail views.
 */
export function CurrencyDisplay({
  amount,
  currency,
  locale = 'en-US',
  colored = true,
  className,
}: CurrencyDisplayProps) {
  const formatted = new Intl.NumberFormat(locale, {
    ...(currency
      ? { style: 'currency', currency }
      : { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
  }).format(amount)

  return (
    <span
      className={cn(
        'tabular-nums font-mono text-sm',
        colored && amount > 0 && 'text-green-600 dark:text-green-400',
        colored && amount < 0 && 'text-destructive',
        className,
      )}
    >
      {formatted}
    </span>
  )
}
